import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  AwsAccountNameInput,
  AwsAccountNameInputSchema,
  AwsAccountNameInputValidation,
} from './AwsAccountNameInput';

export const AwsAccountNameInputExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AwsAccountNameInput',
    component: AwsAccountNameInput,
    schema: AwsAccountNameInputSchema,
    validation: AwsAccountNameInputValidation,
  }),
);
